import { useEffect, useState } from 'react';
import useWebSocket from 'react-use-websocket';
import {
    onSocketClose,
    sendAuth,
    shouldReconnect,
} from '../../services/WebSocketAuth';

/**
 * props:
 * - text
 * - type
 * - onShow (optional, called once the toast is displayed so the parent
 *   can clear its notification and show the same message again)
 */
function Toast(props) {
    const DEFAULT_NOTIFICATION = { type: '', text: '' };

    const [notification, setNotification] = useState(DEFAULT_NOTIFICATION);

    useEffect(() => {
        if (!notification.text) return;

        const notyf = new window.Notyf({
            position: {
                x: 'right',
                y: 'top',
            },
            duration: 3000,
            types: [
                {
                    type: 'info',
                    background: 'blue',
                    dismissible: true,
                },
                {
                    type: 'error',
                    background: 'red',
                    dismissible: true,
                },
                {
                    type: 'success',
                    background: 'green',
                    dismissible: true,
                },
            ],
        });

        notyf
            .open({
                type: notification.type,
                message: notification.text,
            })
            .on('dismiss', ({ target, event }) => {
                setNotification(DEFAULT_NOTIFICATION);
            });
        // Notyf only emits dismiss on a click, not when it closes by
        // itself, so the parent is told as soon as the toast is open.
        if (props.onShow) props.onShow();
        // setNotification(DEFAULT_NOTIFICATION);
    }, [notification]);

    useEffect(() => {
        setNotification({ type: props.type, text: props.text });
    }, [props.type, props.text]);

    const { lastJsonMessage } = useWebSocket(
        process.env.REACT_APP_WS_URL || window._env_?.REACT_APP_WS_URL,
        {
            onOpen: event => {
                sendAuth(event);
                console.log(`Connected to App WS`);
            },
            onClose: onSocketClose,
            onMessage: () => {
                if (lastJsonMessage && lastJsonMessage.notification) {
                    setNotification(lastJsonMessage.notification);
                }
            },
            onError: event => {
                console.error(event);
                setNotification({
                    text: 'Falha na conexao em tempo real. Tentando reconectar...',
                    type: 'error',
                });
            },
            shouldReconnect,
            reconnectInterval: 3000,
        },
    );

    return <></>;
}

export default Toast;
